import actionCreatorFactory from 'typescript-fsa';
import { UserInfo } from '@common/redux/reducers/UserReducer';
import { CommonResult } from '@common/external/Common';
import { MailStopApiResponse } from '@common/external/MailStopApi';
import { OptinMailState } from '../reducers/OptinMailReducer';

const actionCreator = actionCreatorFactory();

export const customerActions = {
  loginUser: {
    updateUser: actionCreator<UserInfo>('UPDATE_USER'),
  },
  updateLogInStatus: actionCreator<boolean>('UPDATE_LOG_IN_STATUS'),
  resetError: actionCreator<void>('RESET_ERROR_STATE'),
  fetchMailUnsubscribe: actionCreator.async<{ customerId: number; token: string }, MailStopApiResponse, CommonResult>(
    'FETCH_MAIL_UNSUBSCRIBE'
  ),
  updateMailPermissionType: actionCreator<OptinMailState>('UPDATE_MAIL_PERMISSION_TYPE'),
};
